import React, { FunctionComponent, useState, SyntheticEvent } from 'react';
import { Radio } from '@blueprintjs/core';

import FilterDayInput from './inputs/FilterDayInput';
import FilterStringInput from './inputs/FilterStringInput';
import FilterUserInput from './inputs/FilterUserInput';
import FilterTagInput from './inputs/FilterTagInput';
import { NO_VALUE_OPERATORS, FILTER_TYPE } from './types';
import FilterFolderInput from './inputs/FilterFolderInput';

type ChangeCallback = (value: any) => void;
type CheckCallback = (event: SyntheticEvent) => void;
type EnterCallback = () => void;


type CustomRadioComponentProps = {
  label: string;
  value: string;
  groupValue?: string;
  fillValue: boolean;
  type: string;
  defaultFilledValue: any;
  onChange: ChangeCallback;
  onCheck: CheckCallback;
  onEnter: EnterCallback;
  name: string;
};

export const CustomRadioButton: FunctionComponent<CustomRadioComponentProps> = ({
  label, value, groupValue, fillValue, type, defaultFilledValue, onChange, onCheck, onEnter, name
}: CustomRadioComponentProps) => {

  const handleFilledValue = (value: any) => {
    onChange(value)
  }

  const getSelectedFilterInputElement = (type: string, value: string) => {
    if (NO_VALUE_OPERATORS.includes(value)) {
      return null
    }
    switch (type) {
      case FILTER_TYPE.DATE:
        return (<FilterDayInput
          operator={value}
          onChange={handleFilledValue}
          defaultFilledValue={defaultFilledValue}
        />)
      case FILTER_TYPE.STRING:
        return (
          <FilterStringInput
            defaultFilledValue={defaultFilledValue}
            onChange={handleFilledValue}
            onEnter={onEnter}
          />
        )
      case FILTER_TYPE.SELECT:
        if (name === 'folder_id') {
          return <FilterFolderInput
            operator={value}
            onChange={handleFilledValue}
            defaultFilledValue={defaultFilledValue}
          />
        }
        return (
          <FilterUserInput
            operator={value}
            onChange={handleFilledValue}
            defaultFilledValue={defaultFilledValue}
          />
        )
      case FILTER_TYPE.TAG:
        return (
          <FilterTagInput
            operator={value}
            defaultFilledValue={defaultFilledValue}
            onChange={handleFilledValue}
          />
        )
    }
  };
  return (
    <div className="custom-radio-button">
      {(type === 'date' && value === 'mtd') && (
        <div className='date-subtitle'>
          Relative
        </div>
      )}
      {(type === 'date' && value === 'gt') && (
        <div className='date-subtitle'>
          Absolute
        </div>
      )}
      <Radio label={label} value={value} checked={groupValue === value} onChange={onCheck} />
      {
        (fillValue && groupValue === value) &&
        getSelectedFilterInputElement(type, value)
      }
    </div>
  );
};

export default CustomRadioButton
